import { pageArgs } from '@/utils'
/**
 * 页面参数
 */
const state = {
  // 分享者
  ...pageArgs.args()
}
const getters = {
  courseId: state => state.courseId,
  albumId: state => state.albumId,
  shareCode: state => state.shareCode
}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
